import { css } from 'styled-components';
import { Grid } from '../../../../components/Grid';
import {
  CtasContainer,
  Heading,
  InlineHeadingWrapper,
  MiniGuideContainer,
  Section,
  SectionText,
  StyledIcon,
  StyledImage,
  StyledPrimaryCta,
  StyledSecondaryCta,
  Subheading,
} from '../../../../components/MiniGuide/styles';
import mediaQuery from '../../../../helpers/mediaQuery';
import spacing from '../../../../helpers/spacing';
import { colors } from '../../colors';

export default css`
  ${Heading} {
    text-align: left;
    color: ${colors.neutral01};
  }

  ${Subheading} {
    text-align: left;
    margin-top: ${spacing(2)};
    color: ${colors.neutral01};
  }

  ${InlineHeadingWrapper} {
    margin-bottom: ${spacing(3)};
  }

  ${CtasContainer} {
    margin-top: ${spacing(1)};
  }

  &${MiniGuideContainer} {
    ${Grid} {
      justify-content: left;
    }
  }

  ${StyledImage} {
    margin-bottom: ${spacing(3)};

    ${mediaQuery.tabletLandscape`
    margin-bottom: 0;
  `}
    ${mediaQuery.desktop`
    margin-bottom: 0;
  `}
  }

  ${Section} {
    & > * {
      color: ${colors.neutral01};
    }
    ${StyledIcon} {
      margin-top: ${spacing(0.5)};
    }
  }

  ${SectionText} {
    h3 {
      margin-bottom: ${spacing(2)};
    }
  }

  ${CtasContainer} {
    margin-left: 0;
  }

  ${StyledPrimaryCta}, ${StyledSecondaryCta} {
    margin-left: 0;
    margin-right: 0;
    &:first-child {
      margin-right: ${spacing(2)};
    }

    &:nth-child(2) {
      margin-left: ${spacing(2)};
    }
  }
`;
